module.exports = __webpack_public_path__ + "img/b00d0b06fba788eb4a3c4385f9bf38d6.f88e7b04.webp";